import GooglePlaces from '../modules/places'

up.compiler('[places-search]', (element, data) => {

  const apiKey = data.apiKey
  const searchInput = document.querySelector('[name^="search[address]"]')

  new GooglePlaces(apiKey, searchInput).then((instance) => {
    element.placesInstance = instance // for tests
  })

  function onPlaceChanged() {
    if (document.querySelector('.training-grounds--map') === null) {
      up.submit(searchInput.closest('form'))
    }
  }

  up.on(searchInput, 'app:map:placeChanged', onPlaceChanged)
})
